// extracted by mini-css-extract-plugin
export default {"card":"m0-z","carouselContainer":"n0-z","carouselContent":"o0-z"};